import { LoginLayout } from 'layouts'
import { LoginForm } from './LoginForm'
import { useEffect } from 'react'

export const Login = () => {
    // document.title = 'KL-MegaShare - Make Each Goal Available'

    useEffect(() => {
        window.history.pushState(null, '', window.location.origin) // 重置浏览器地址栏，不触发浏览器刷新
    }, [])

    return (
        <LoginLayout>
            <LoginForm />
        </LoginLayout>
    )
}
